// i18n transliterations
const TRANSLITERATOR_TABLE = {
    standard: {
        À: 'A',
        Á: 'A',
        Â: 'A',
        Ã: 'A',
        Ä: 'A',
        Å: 'A',
        Æ: 'AE',
        Č: 'C',
        Ç: 'C',
        È: 'E',
        É: 'E',
        Ê: 'E',
        Ë: 'E',
        Ì: 'I',
        Í: 'I',
        Î: 'I',
        Ï: 'I',
        Ð: '?',
        Ñ: 'N',
        Ò: 'O',
        Ó: 'O',
        Ô: 'O',
        Õ: 'O',
        Ö: 'O',
        Ø: 'O',
        Š: 'S',
        Ù: 'U',
        Ú: 'U',
        Û: 'U',
        Ü: 'U',
        Ý: 'Y',
        Þ: '?',
        ß: 'ss',
        à: 'a',
        á: 'a',
        â: 'a',
        ã: 'a',
        ä: 'a',
        å: 'a',
        ā: 'a',
        æ: 'ae',
        č: 'c',
        ç: 'c',
        è: 'e',
        é: 'e',
        ê: 'e',
        ë: 'e',
        ì: 'i',
        í: 'i',
        î: 'i',
        ï: 'i',
        ī: 'i',
        ð: '?',
        ñ: 'n',
        ò: 'o',
        ó: 'o',
        ô: 'o',
        õ: 'o',
        ö: 'o',
        ø: 'o',
        š: 's',
        ù: 'u',
        ú: 'u',
        û: 'u',
        ü: 'u',
        ý: 'y',
        þ: '?',
        ÿ: 'y'
    },
    da: {
        Ø: 'O'
    },
    de: {
        ä: 'ae',
        ö: 'oe',
        ü: 'ue',
        Ä: 'Ae',
        Ö: 'Oe',
        Ü: 'Ue',
        ß: 'ss'
    },
    fi: {
        Î: 'OE',
        Ü: 'Y',
        ü: 'y',
        Ũ: 'Y',
        ũ: 'y',
        Đ: 'D',
        đ: 'd',
        þ: 'TH',
        Þ: 'th',
        Š: 'SH',
        š: 'sh',
        Ž: 'ZH',
        ž: 'zh'
    }
};

/**
 * transliterate()
 * @param {*} string
 * @param {*} lang
 */
export function transliterate(string, lang) {
    let transliteratedString = '';
    for (let i = 0; i < string.length; i++) {
        let stringChar = string.charAt(i);
        let lookup = TRANSLITERATOR_TABLE[lang] || {};
        transliteratedString +=
            lookup[stringChar] ||
            TRANSLITERATOR_TABLE.standard[stringChar] ||
            stringChar;
    }
    return transliteratedString;
}

/**
 * normalize()
 * Helper function to create normalized search tokens
 * @param {*} string
 * @param {*} lang
 */
export function normalize(string, lang) {
    return transliterate(string, lang)
        .replace(/(-|,)/g, ' ')
        .replace(/[^0-9a-zA-Z\s]+/g, '')
        .replace(/\s+/g, ' ')
        .trim()
        .toLowerCase();
}
